import { Button } from "@/components/ui/button";
import { Eye, Download, Trash } from "lucide-react";

interface DocumentActionsProps {
  onPreview: () => void;
  onDownload: () => void;
  onDelete: () => void;
}

export const DocumentActions = ({
  onPreview,
  onDownload,
  onDelete,
}: DocumentActionsProps) => {
  return (
    <div className="flex items-center gap-2">
      <Button
        variant="outline"
        size="sm"
        onClick={onPreview}
      >
        <Eye className="h-4 w-4" />
      </Button>
      <Button
        variant="outline"
        size="sm"
        onClick={onDownload}
      >
        <Download className="h-4 w-4" />
      </Button>
      <Button
        variant="outline"
        size="sm"
        onClick={onDelete}
        className="text-destructive hover:text-destructive"
      >
        <Trash className="h-4 w-4" />
      </Button>
    </div>
  );
};